import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../../../components/common/HeroSection/HeroSection';
import Images from "../../../assets/images/index"

const Hero = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/portfolio');

        setTimeout(() => {
        const element = document.getElementById('apply-section');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        }, 100); 
    };

    return (
        <HeroSection
            badgeText="Best Web Development Company In Surat, India"
            title="We Develop Website  That "
            highlight=" Drives Business Growth"
            subtitle="At DGMTech Solutions, Surat’s leading web development company, we engineer high-performance, responsive, and scalable websites optimized for speed and reliability, empowering your brand to stay ahead in an ever-evolving digital ecosystem."
            buttonLabel="Start Your Web project"
            // buttonLink="/contact"
            image={Images.webHero}
            onClick={handleClick}
        />
    );
};

export default Hero;
